goog.provide('el8.ptdata.hccScoreDetails');

// HACK WARNING!
//
// Fake import to make sure el8.ptdata.model exists. deps ordering is not working i.e.
// where this file is sourced before el8.ptdata.model exists when being minifed by Closure.
// By requiring this we make force a change in ordering that makes el8.ptdata.model exist.
//
// I've looked at the minified JS and this is really strange. This is ugly but I don't have
// any other ideas at the moment.
goog.require('el8.ptdata.model.med.base');

goog.require('el8.model.base');
goog.require('el8.service.urls');

var hccScoreKeysMap = {
    'community_nondual_aged': 'communityNondualAged',
    'institutional': 'institutional',
    // Several additional keys are provided, but we never display them
    // 'community_nondual_disabled',
    // 'community_fbdual_aged',
    // 'community_fbdual_disabled',
    // 'community_pbdual_aged',
    // 'community_pbdual_disabled',
}

var hccScoreYears = {
    '2023':{
        "totalsDescription":"‘Total’ displayed is from model v24",
        "columns": ['v24']
    },
    '2024':{
        "totalsDescription":"‘Total’ displayed is a weighted blend of model v24 (67%) & v28 (33%)",
        "columns": ['v24','v28','blended'],
        "blend": {'v24': 0.67, 'v28': 0.33 }
    },
    '2025':{
        "totalsDescription":"‘Total’ displayed is a weighted blend of model v24 (33%) & v28 (67%)",
        "columns": ['v24','v28','blended'],
        "blend": {'v24': 0.33, 'v28': 0.67 }
    },
    '2026':{
        "totalsDescription":"‘Total’ displayed is from model v28",
        "columns": ['v28']
    },
}


    el8.ptdata.hccScoreDetails = (function() {
        var _class = function(spec) { this.populate(spec); };
        _class.inheritsFrom(el8_Entity);

        _class.addProperty('totalsDescription', true);

        // Column headers for the data
        _class.addProperty( 'headerRow',true, []);

        // The columns keys to loop through when making the table
        _class.addProperty( 'columns',true, []);

        // List of rows, should always have Demographic row but that row's scores may be "N/A"
        _class.addProperty( 'scoredItems',true, []);

        // List of rows after the scored items, for subtotals and modifications
        _class.addProperty( 'summaryRows',true, []);

        // A simple _hccScoreTypeClass with the grand total scores for community and institutional
        _class.addProperty('totals', true);

        // quick access to totals.community_nondual_aged and totals.institutional with only 2 digits past the decimal
        _class.addProperty('communityFinal', true);
        _class.addProperty('institutionalFinal', true);

        /*
            Accepts a variety of backend source formats, like null or some with community_nondual_aged_factor or
            community_nondual_aged, and returns an object with keys matching Object.values(hccScoreKeysMap) and
            values of either "-" or the source's value when it is numeric.
         */
        _class.makeHccScoreObject = function(source,keyExtra) {
            // Guard against null.hasOwnProperty or nullish keyExtra
            var spec = source || {}
            var keyExten = keyExtra || ""

            // Recurse to automatically support "_factor"
            if (keyExten === "" && spec.hasOwnProperty("community_nondual_aged_factor")){
                return _class.makeHccScoreObject(source,"_factor")
            }

            var standardizedScores = {}
            Object.keys(hccScoreKeysMap).forEach(function (scoreKey) {
                var val = spec.hasOwnProperty(scoreKey+keyExten) ? spec[scoreKey+keyExten] : undefined
                standardizedScores[hccScoreKeysMap[scoreKey]] = (typeof val === "number") ? val : "-"
            })
            return standardizedScores
        }

        _class.makeGetScoresFromVersionedData = function(versions){
            return function (versionedData, targetKey, scoreKeysExtra) {
                var ret = {}

                versions.forEach(function (ver){
                    ret[ver] = _class.makeHccScoreObject(versionedData[ver][targetKey], scoreKeysExtra)
                })
                return ret
            }
        }

        _class.makeSameRowOnBothTabs = function(rowData){
            var ret = {}
            Object.values(hccScoreKeysMap).forEach(function (ver){
                ret[ver] = rowData
            })
            return ret
        }

        /*
        Generally adheres to the format of
        {
            "description": string,
            "scoresByColumn": {
                "<version | blended>": HccScoreObject from makeHccScoreObject
            },
            "isScores": boolean,
            "bold": boolean
        }
        with the exception that one may have modified HccScoreObjects to have non-numeric scores for output
         */
        _class.makeHccRowObject = function(description, versions, isScores, bold){
            var columnData = {};

            if (Array.isArray(versions)){
                versions.forEach(function (ver){
                    columnData[ver] = _class.makeHccScoreObject()
                })
            } else {
                columnData = versions
            }
            return {
                "description": description,
                "scoresByColumn": columnData,
                "isScores": (isScores == false) ? false : true, // in numeric columns, use el8HccScore class
                "bold": bold || false,
            }
        }

        /* A way to get rows of scores from lists of versioned data, deduplicating by presentation text */
        _class.deduplicateVersionedDataList = function(data, versions, dataKey, subKey){
            // legacy doesn't have sets, use keys on an object
            var tempSet = {}

            versions.forEach(function (ver){
                var currList = Array.isArray(data[ver][dataKey]) ? data[ver][dataKey] : []
                currList.forEach(function (item) {
                    var name = item[subKey]
                    if (!tempSet.hasOwnProperty(name)){
                        // Make a row with entries across versions in case the other version never hits this name
                        tempSet[name] = _class.makeHccRowObject(name,versions)
                    }
                    tempSet[name]["scoresByColumn"][ver] = _class.makeHccScoreObject(item)
                })
            })
            return Object.values(tempSet)
        }

        /*
        Modifies hccRow in place, adding then filling the "blended" column
         */
        _class.addCalculatedBlendedColumn = function(hccRow, versions, year){
            var blends = {}
            Object.keys(hccScoreKeysMap).forEach(function (score){
                blends[score] = 0

                versions.forEach(function (ver){
                    var val = hccRow["scoresByColumn"][ver][hccScoreKeysMap[score]]
                    var contribution = (typeof val === "number") ? val * hccScoreYears[year].blend[ver] : 0
                    blends[score] += contribution
                })
                blends[score] = blends[score] == 0 ? "" : Number(blends[score].toFixed(3))
            })
            hccRow["scoresByColumn"]["blended"] = _class.makeHccScoreObject(blends)
        }

        _class.prototype.refresh = function(cb) {
            var that = this;
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('hccScore',["current"]),
                success: function(data) {
                    var spec = {}
                    try {
                        var year = data["totals"]["year"]
                        var doBlend = hccScoreYears[year].hasOwnProperty("blend")

                        var versions = doBlend
                            ? Object.keys(hccScoreYears[year].blend)
                            : hccScoreYears[year]["columns"]

                        var getVersionScores = _class.makeGetScoresFromVersionedData(versions)

                        var headers = {}

                        versions.forEach(function (ver){
                            // The headers for versions are always the version itself
                            headers[ver]=_class.makeSameRowOnBothTabs(ver)
                        })


                        // The item rows include all the rows before the raw total, starting with Demographics
                        var scoredItems = [
                            _class.makeHccRowObject(
                                "Demographic",
                                getVersionScores(data,"demographics")
                            ),
                        ]

                        scoredItems.addArray(_class.deduplicateVersionedDataList(data, versions, "diseases", "label"))
                        scoredItems.addArray(_class.deduplicateVersionedDataList(data, versions, "disease_interactions", "description"))

                        if (versions.reduce(function (accum,curr) {
                            return (data[curr]["count_factor"]) ? true : accum
                        },false)){
                            // At least one version has a count factor object, add the row for that
                            scoredItems.push(_class.makeHccRowObject(
                                "Count Factor",
                                getVersionScores(data,"count_factor")
                            ))
                        }

                        // Fill normalization and intensity last column with real data
                        var lastCol = hccScoreYears[year]["columns"][hccScoreYears[year]["columns"].length - 1]
                        var normalizations = {}
                        var codingIntensities = {}
                        var norms = data["multiplicative_factors"]["normalization_factor"]
                        var ci = data["multiplicative_factors"]["coding_intensity_adjustment"]
                        normalizations[lastCol] = _class.makeSameRowOnBothTabs("÷" + norms)
                        codingIntensities[lastCol] = _class.makeSameRowOnBothTabs("-" + ci + "%")

                        var summaryRows = [
                            _class.makeHccRowObject(
                                "Raw Total",
                                getVersionScores(data,"totals","_raw"),
                                true,
                                true
                            ),
                            _class.makeHccRowObject(
                                "Normalization",
                                normalizations,
                                false
                            ),
                            _class.makeHccRowObject(
                                "Normalized Total",
                                getVersionScores(data,"totals","_normalized")
                            ),
                            _class.makeHccRowObject(
                                "Coding Intensity",
                                codingIntensities,
                                false
                            ),
                        ]

                        if (doBlend){
                            headers["blended"] = _class.makeSameRowOnBothTabs("Blended")

                            // Blend raw total and normalized totals
                            _class.addCalculatedBlendedColumn(summaryRows[0],versions,year)
                            _class.addCalculatedBlendedColumn(summaryRows[2],versions,year)

                            // After the blend for normalized totals, we drop its versioned columns
                            versions.forEach(function (ver) {
                                delete summaryRows[2]["scoresByColumn"][ver]
                            })

                            // Now blend the scored items
                            scoredItems.forEach(function (item){
                                _class.addCalculatedBlendedColumn(item,versions,year)
                            })
                        }

                        // Cast zeros (and nulls cast to 0) to "" for clean display
                        hccScoreYears[year].columns.forEach(function (col) {
                            Object.values(hccScoreKeysMap).forEach(function (score) {
                                if (scoredItems[0]["scoresByColumn"][col][score] === 0){
                                    scoredItems[0]["scoresByColumn"][col][score] = ""
                                }
                            })
                        })

                        // Core data for the class
                        spec["scoredItems"] = scoredItems
                        spec["summaryRows"] = summaryRows
                        spec["totals"] = _class.makeHccScoreObject(data["totals"])

                        spec["totals_description"] = hccScoreYears[year]["totalsDescription"]
                        spec["columns"] = hccScoreYears[year]["columns"]

                        spec["community_final"] = data["totals"]["community_nondual_aged"].toFixed(2)
                        spec["institutional_final"] = data["totals"]["institutional"].toFixed(2)


                        spec["headerRow"] = _class.makeHccRowObject(
                            "Description",
                            headers,
                            false,
                            true)

                        that.populate(spec);
                        if (cb) { cb(spec); }
                    } catch(e) {
                        var msg="Error initializing el8 HCC score details: " + e
                        console.error(msg)
                        // Send the error to sentry
                        UIM && UIM.logError(msg);
                        // Log how far we got building spec
                        console.log("el8 HCC score details built spec to this point:", spec);
                    }
                }
            });
        };

        _class.prototype.refreshIfHccScoreEnabled = function() {
            // refresh HCC score if setting is on
            if (el8.data.practiceSettings.isHccScoringEnabled()) {
                try {
                    this.refresh(el8.appchart.refpanel.demog.triggerRender);
                } catch(err) {
                    // if we get here, then it's likely this method was called
                    // outside the patient chart. Don't need to throw an error
                }
            }
        };

        el8.ptdata.model.hccScoreDetails = function(spec) { return new _class(spec); };

        return el8.ptdata.model.hccScoreDetails({});
    })();
